// extracted by mini-css-extract-plugin
export default {"shdowStyle":"SearchInputs_shdowStyle__toQZ8"};